// extracted by mini-css-extract-plugin
export default {"Dialog":"PasteSpecialDialog_Dialog__QAEKx","Title":"PasteSpecialDialog_Title__Vvhuf","Options":"PasteSpecialDialog_Options__3BoSg"};